import * as React from "react";
import {useState, useEffect, MouseEventHandler} from 'react';
import { jfetch, toast } from "../../utils";
import PageContainer from "../core/PageContainer";
import ModernCard from "../core/ModernCard";
import Breadcrumbs from "../core/Breadcrumbs";
import { useParams, useHistory } from "react-router-dom";
import {arrayMove, SortableContainer, SortableElement} from 'react-sortable-hoc';

interface IProps {
  userContext:any;
}

function QuoteCalculatorOrder(props:IProps){
  const [serviceCategories, setServiceCategories] = useState([])
  const [projectServiceCategories, setProjectServiceCategories] = useState([])
  const [productCategories, setProductCategories] = useState([])
  const [chargeCategories, setChargeCategories] = useState([])
  const {calculator_id}:any = useParams()
  let history = useHistory()
  const [name, setName] = useState('')


  useEffect(() => {
    jfetch
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}`)
    .then((resp) => {
      setName(resp.calculator.name)
    })
    jfetch
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/products`)
    .then((resp) => {
      setProductCategories(resp)
    }) 
    jfetch
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/services`)
    .then((resp) => {
      setServiceCategories(resp)
    }) 
    jfetch
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/project_services`)
    .then((resp) => {
      setProjectServiceCategories(resp)
    })     
    jfetch
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/charges`)
    .then((resp) => {
      setChargeCategories(resp)
    })      
  }, [])


  const PC = Object.keys(productCategories).map((keyname, i) => {
    return  (
      <ItemCategory 
        category={keyname} 
        items={productCategories[keyname]} 
        org_id={props.userContext.org.id} 
        calculator_id={calculator_id} 
        key={`${keyname}-${i}`} 
        item_type='products'
      />
    )
  })

  const SC = Object.keys(serviceCategories).map((keyname, i) => {
    return  (
      <ItemCategory 
        category={keyname} 
        items={serviceCategories[keyname]} 
        org_id={props.userContext.org.id} 
        calculator_id={calculator_id} 
        key={`${keyname}-${i}`} 
        item_type='services'
      />
    )
  })

  const PSC = Object.keys(projectServiceCategories).map((keyname, i) => {
    return  (
      <ItemCategory 
        category={keyname} 
        items={projectServiceCategories[keyname]} 
        org_id={props.userContext.org.id} 
        calculator_id={calculator_id} 
        key={`${keyname}-${i}`} 
        item_type='project_services'
      />
    )
  })
  
  const CC = Object.keys(chargeCategories).map((keyname, i) => {
    return  (
      <ItemCategory 
        category={keyname} 
        items={chargeCategories[keyname]} 
        org_id={props.userContext.org.id} 
        calculator_id={calculator_id} 
        key={`${keyname}-${i}`} 
        item_type='charges'
      />
    )
  })

  // function buildCategory(case_string){
  //   let final = []
  //   switch (case_string) {
  //     case 'products':
  //       final = Object.keys(productCategories).map((keyname, i) => <ItemCategory category={keyname} products={productCategories[keyname]} org_id={props.userContext.org.id} calculator_id={calculator_id} key={`${keyname}-${i}`} /> )
  //       break;

  //     default:
  //       break;
  //   }
  //   return final
  // }

  return (
    <PageContainer>   
      <Breadcrumbs
        crumbs={[
          {
            label: "Pricing Quote Dashboard",
            route: "/quote_calculator",
            routerLink: true,
          },
          { label: "Order Calculator" },
        ]}
      />
      <div className="quote-calc-new-root">
        <div className="row">
          <div className="col-lg-12">
            <ModernCard ta="center">
              <h3>{name}</h3>
            </ModernCard>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">

            {/* Nav tabs */}
            <ul className="nav nav-tabs" role="tablist" style={{borderBottom:'none'}}>
              <li role="presentation" className="active">
                <a href="#services" aria-controls="services" role="tab" data-toggle="tab" style={{border:'none'}}>
                  <h4>Monthly Services</h4>
                </a>
              </li>
              <li role="presentation">
                <a href="#products" aria-controls="products" role="tab" data-toggle="tab" style={{border:'none'}}>
                  <h4>Monthly Products</h4>
                </a>
              </li>
              <li role="presentation">
                <a href="#charges" aria-controls="charges" role="tab" data-toggle="tab" style={{border:'none'}}>
                  <h4>One-Time Project</h4>
                </a>
              </li>
              <li role="presentation">
                <a href="#projectlabor" aria-controls="projectlabor" role="tab" data-toggle="tab" style={{border:'none'}}>
                  <h4>Project Labor</h4>
                </a>
              </li>        
            </ul>      

            {/* Tab panes */}
            <div className="tab-content">
              <div role="tabpanel" className="tab-pane active" id="services">
                <div className="row">
                  <div className="col-lg-12">
                    <ModernCard ta="left" m="3px 0px 20px 0px" br="0px 0px 20px 20px">
                      {SC}
                    </ModernCard>
                  </div>
                </div>          
              </div>
              <div role="tabpanel" className="tab-pane" id="products">
                <div className="row">
                  <div className="col-lg-12">
                    <ModernCard ta="left" m="3px 0px 20px 0px" br="0px 0px 20px 20px" p="15px 18px 30px 18px">
                      {PC}
                    </ModernCard>
                  </div>
                </div>          
              </div>
              <div role="tabpanel" className="tab-pane" id="charges">
                <div className="row">
                  <div className="col-lg-12">
                    <ModernCard ta="left" m="3px 0px 20px 0px" br="0px 0px 20px 20px">
                      {CC}
                    </ModernCard>
                  </div>
                </div> 
              </div>
              <div role="tabpanel" className="tab-pane" id="projectlabor">
                <div className="row">
                    <div className="col-lg-12">
                      <ModernCard ta="left" m="3px 0px 20px 0px" br="0px 0px 20px 20px">
                        {PSC}
                      </ModernCard>
                    </div>
                  </div>    
              </div>        
            </div> 


          </div>
        </div>
      </div>          
    </PageContainer>
  )
}

function ItemCategory(props){
  const [items, setItems] = useState(props.items)
  const SortableItem = SortableElement(({item}) => (
    <p key={item.id} style={{marginBottom:'4px', padding:'4px 8px', backgroundColor:'#f1f7fd', fontSize:'16px'}} className="line-item">
      <i className="fa fa-bars" style={{marginRight:'8px'}} />{item.name}
    </p>
  ) );

  const SortableList = SortableContainer(({items}) => {
    return (
      <div style={{paddingLeft:'18px', padding:'18px 18px', border:'1px solid #6893d1', borderRadius:'5px'}}>
        {items.map((item, i) => {
          return (
            <SortableItem key={item.id} index={i} item={item} />
          )
        })}
      </div>
    );
  });

  const onSortEnd = ({oldIndex, newIndex}) => {
    let new_order = arrayMove([...items], oldIndex, newIndex)
    setItems(new_order)
    jfetch.post(`/organizations/${props.org_id}/quote_calculator/quote_calculator/${props.calculator_id}/reorder`, {item_type:props.item_type, items:new_order})
    .then((resp) => {
      // console.log('resp:', resp)
    })
  };


  return (
    <div style={{color:'black'}}>
      <div>
        <h4>{props.category}</h4>
      </div>
      <div style={{ overflowY:'scroll'}}>
        <SortableList items={items} onSortEnd={onSortEnd} pressDelay={100} />
      </div>
  </div>
  )
}

export default QuoteCalculatorOrder;


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/QuoteCalculatorOrder.tsx